<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست کد های تخفیف ریفرال </template>
    <template #titleBtn>
      <BButton variant="success" to="/apps/referral-discounts/create">
        ایجاد کد جدید
      </BButton>
    </template>
    <CustomTable
      v-if="masterDiscountCodesList"
      ref="masterDiscountCodesList"
      :pageNumber="masterDiscountCodesFilters.pageNumber"
      :count="masterDiscountCodesFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="masterDiscountCodesList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (masterDiscountCodesFilters.pageNumber - 1) *
                masterDiscountCodesFilters.count
          )
        }}
      </template>
      <template #masterUserFullName="data">
        <b-link :to="`/users/${data.item.masterUserId}`">
          {{ data.item.masterUserFullName }}
        </b-link>
      </template>
      <template #actions="data">
        <BButton
          variant="primary"
          size="sm"
          @click="renderRowDetails(data.index)"
        >
          مشاهده جزئیات
        </BButton>
      </template>
      <template #cellDetails="data">
        <MasterDiscountCodeDetailSection
          :discountCodesList="data.item.masterDiscountCodes"
        ></MasterDiscountCodeDetailSection>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllMasterDiscountCodes();
  },
  data() {
    return {
      isLoading: false,
      masterDiscountCodesList: null,
      totalCount: null,
      masterDiscountCodesFilters: {
        pageNumber: 1,
        count: 10,
      },
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "masterUserFullName",
          label: "نام استاد",
        },
        {
          key: "masterDiscountCodes",
          label: "تعداد کد های تخفیف این استاد",
          formatter: (val) => `${val.length} کد`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderRowDetails(index) {
      if (this.$refs.masterDiscountCodesList) {
        this.$refs.masterDiscountCodesList.showRowDetails(index);
      }
    },
    changePage(pageNumber) {
      this.masterDiscountCodesFilters.pageNumber = pageNumber;
      this.getAllMasterDiscountCodes();
    },
    async getAllMasterDiscountCodes() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllDiscountCodes = new GetAllDiscountCodes(_this);
        getAllDiscountCodes.setRequestParamDataObj(
          _this.masterDiscountCodesFilters
        );
        await getAllDiscountCodes.fetch((res) => {
          _this.masterDiscountCodesList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    MasterDiscountCodeDetailSection,
    BButton,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import MasterDiscountCodeDetailSection from "@/views/components/MasterDiscountCode/MasterDiscountCodeDetailSection.vue";
import { GetAllDiscountCodes } from "@/libs/Api/MasterDiscountCodes";
import { BButton, BLink } from "bootstrap-vue";
</script>
